export const capitalize = (value: string) => value.toUpperCase()
